import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import NavigateBack from 'actions/current_location/navigate_back';
import { useExecuteAction } from 'components/hooks/connect_hooks';
import connect from 'components/lib/connect';
import ProfileAvatar from 'components/lib/profile_avatar';
import { useMobilePanel } from 'components/mobile/mobile_context';
import MobilePanelMenu from 'components/mobile/mobile_panel_menu';

export function MobileCustomerHeader({ customerName, customerImage }) {
  const executeAction = useExecuteAction();
  const { mobilePanel, closeMobilePanel } = useMobilePanel();

  const handleBack = useCallback(() => {
    if (mobilePanel) {
      closeMobilePanel();
      return;
    }
    executeAction(NavigateBack);
  }, [mobilePanel, closeMobilePanel, executeAction]);

  return (
    <HeaderContainer data-aid="mobileCustomerHeader">
      <BackButton aria-label="Go back" data-aid="mobileBackButton" onClick={handleBack} type="button">
        <BackArrow>&#8592;</BackArrow>
      </BackButton>
      <AvatarWrapper>
        <ProfileAvatar profile={{ name: customerName, image: customerImage }} />
      </AvatarWrapper>
      <CustomerName data-aid="mobileCustomerName">{customerName || 'Customer'}</CustomerName>
      <MobilePanelMenu />
    </HeaderContainer>
  );
}

MobileCustomerHeader.propTypes = {
  customerImage: PropTypes.string,
  customerName: PropTypes.string,
};

function mapStateToProps({ getProvider }) {
  const profileProvider = getProvider('profile');
  const profile = profileProvider.get();

  return {
    customerName: (profile && profile.name) || '',
    customerImage: profile && profile.getImageUrl ? profile.getImageUrl() : undefined,
  };
}

export default connect(mapStateToProps)(MobileCustomerHeader);

const HeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
  min-width: 0;
  padding-right: 12px;
`;

const BackButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  width: 40px;

  &:active {
    opacity: 0.6;
  }
`;

const BackArrow = styled.span`
  color: ${p => p.theme.colors.gray800};
  font-size: 22px;
`;

const AvatarWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
`;

const CustomerName = styled.div`
  color: ${p => p.theme.colors.gray900};
  flex: 1;
  font-size: var(--font-size-medium);
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
